var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 51,
    viewBox: "0 0 80 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_16190)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1047 12.5931C10.475 14.4327 9.92578 17.9041 9.48518 21.412C9.041 24.8945 8.69456 28.4098 8.84703 30.3311C8.94587 31.8363 9.98027 32.6782 11.6207 32.8308L59.4655 38.9276C61.6236 39.2298 63.673 39.4956 64.6474 39.4367C66.8099 39.294 68.3682 38.7554 68.841 37.599C69.7392 35.4634 70.4327 32.3541 70.8219 29.2151C71.2221 26.0798 71.3361 22.8966 70.996 20.5986C70.8206 19.3574 69.435 18.4458 67.379 17.7676C66.4523 17.4685 64.4028 17.2027 62.2374 16.9584L14.3926 10.8616C12.7741 10.6078 11.5743 11.1581 11.0938 12.5894L11.1047 12.5931Z",
    fill: "#D41128"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1104 37.9262L45.7719 36.4177C44.711 36.2305 44.1321 35.9034 44.1035 35.6646L44.0069 34.9444C43.9855 34.7924 44.5179 34.754 45.2928 34.8573L46.915 35.0641C48.6749 35.293 50.1051 35.5318 51.1296 35.8275L54.4057 36.7585C55.1225 36.9629 55.6183 37.1777 55.5926 37.3621L55.5047 37.9479C55.49 38.0636 54.7222 38.0471 54.1067 37.937L54.1104 37.9262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5868 35.7537L51.0188 37.3104L45.7905 36.3635C45.4139 36.2974 45.0483 36.1988 44.6972 36.0568C44.082 35.802 44.1691 35.6503 44.0798 34.9446C44.0981 34.818 45.0433 34.882 45.1592 34.8968C46.9769 35.133 48.8056 35.3367 50.5905 35.7429L50.5868 35.7537Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6018 37.4096L51.1842 35.9181C52.5417 36.3014 53.9537 36.5945 55.2531 37.1152C55.6584 37.3116 55.5097 37.4306 55.4473 37.9043C55.3167 38.0052 54.3897 37.8871 54.2377 37.8722L51.6054 37.3987L51.6018 37.4096Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5083 38.0455C55.6821 38.0677 55.8196 38.1621 56.0002 38.4158C56.2965 38.829 56.1043 39.0057 55.9297 39.4177C55.7479 39.8513 55.8422 39.7864 55.4865 40.1979C55.2724 40.4397 55.0623 40.4537 54.7401 40.4058C54.5663 40.3836 54.4253 40.2277 54.4799 40.0651L55.1783 38.3088C55.2329 38.1461 55.3562 38.0307 55.5192 38.0492L55.5083 38.0455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5441 38.0456C55.7142 38.0786 55.8662 38.202 56.0143 38.4086C56.0649 38.4738 56.0938 38.5318 56.119 38.6006C56.4093 38.2758 56.664 37.5891 56.3454 37.5304C56.0666 37.4609 55.9362 37.4895 55.8094 37.5073C55.65 37.5141 55.5227 37.8213 55.5513 38.0601L55.5441 38.0456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5084 36.3312L44.8777 36.3828C45.1312 36.4197 45.3375 36.4889 45.3338 36.5359L45.2898 36.8831C45.2861 36.9301 45.0723 36.9549 44.8189 36.9181L44.4495 36.8665C44.1961 36.8296 43.9897 36.7604 43.9934 36.7133L44.0375 36.3662C44.0448 36.3083 44.2549 36.2944 44.5084 36.3312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4404 34.006L43.4182 34.2881C47.3434 34.7975 50.9644 35.2772 51.5472 35.4487L51.5509 35.4379C54.4579 36.1725 56.4191 37.2774 58.3784 37.3439C59.7546 37.3837 60.1651 36.6287 60.507 35.7903C61.5363 33.2643 62.1744 30.7518 62.4975 28.1698C62.8206 25.5877 62.8757 23.0122 62.482 20.298C62.3604 19.4005 62.1445 18.5679 60.7977 18.2606C58.8897 17.8251 56.712 18.4091 53.7132 18.3796L45.562 17.4649L45.5253 17.7542L53.5896 18.6398C53.5956 21.5012 53.5257 24.2649 53.177 26.9952C52.8282 29.7255 52.1898 32.4189 51.4825 35.1736C50.9903 34.948 48.4085 34.6483 43.4476 34.0205L43.4404 34.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8066 20.5106C53.7801 23.2888 53.6051 26.0775 53.1296 28.8255C52.8878 30.4456 52.4794 32.0941 52.1 33.692C51.9723 34.2163 51.8338 34.7368 51.6989 35.2465C53.585 35.747 55.4054 36.5512 57.3134 36.9867C58.186 37.159 59.2397 37.2956 59.8495 36.523C60.2452 35.9922 60.5146 35.1537 60.7366 34.5284C62.3523 30.0758 62.9114 25.0272 62.2385 20.3372C62.1454 19.7147 62.0304 19.1573 61.4806 18.7797C60.4602 18.1837 58.8193 18.3206 57.6819 18.3972C56.4213 18.5169 55.1028 18.6292 53.8279 18.6115C53.7879 18.7307 53.82 19.0311 53.8125 19.1613C53.8118 19.5954 53.8146 20.0548 53.7994 20.4961L53.8066 20.5106Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7122 27.4314L63.8946 22.389C63.8911 22.3275 64.0071 22.2699 64.0976 22.2882L65.0606 22.5512C65.1837 22.5805 65.2559 22.6892 65.2522 22.7362L65.0739 27.4783C65.0702 27.5253 64.9796 27.5793 64.8709 27.5791L63.904 27.544C63.7953 27.5437 63.7049 27.4892 63.7122 27.4314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2715 36.9939C63.8418 38.3819 64.7311 39.3682 66.4462 38.2187C66.9937 37.8475 68.1473 36.7508 68.4192 34.5014C67.2418 34.6611 64.6212 35.8444 64.2607 36.9903L64.2715 36.9939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7289 20.1001L12.5931 21.1524C12.5712 21.2898 12.5239 21.3946 12.4768 21.3909L12.3609 21.3761C12.3139 21.3724 12.2923 21.2566 12.3143 21.1192L12.4501 20.0668C12.4721 19.9294 12.5193 19.8246 12.5664 19.8283L12.6823 19.8431C12.7294 19.8469 12.7509 19.9627 12.7289 20.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1182 14.5844C13.1623 14.201 13.1121 13.8825 13.018 13.8751L12.1381 13.7606C12.0331 13.7495 11.558 14.1209 11.5066 14.4897C10.9259 17.3714 10.5131 19.4287 10.2488 21.5117C9.99172 23.573 9.86134 25.6889 9.70784 28.6296C9.671 28.9912 10.0287 29.4733 10.1338 29.4844L11.0137 29.5988C11.1078 29.6063 11.2278 29.3208 11.2828 28.9411C11.4282 26.5286 11.6025 24.1379 11.9072 21.7186C12.2119 19.2992 12.5781 16.9488 13.1073 14.5807L13.1182 14.5844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1417 13.8221C11.8953 13.8721 11.6266 14.2766 11.5647 14.4971C11.1738 16.4894 10.6995 18.5139 10.4425 20.5391C10.0215 23.1969 9.93347 25.9423 9.75868 28.6225C9.78003 28.8468 9.92774 29.3066 10.1557 29.4194L11.0248 29.5301C11.2971 29.1148 11.266 28.2719 11.2921 27.798C11.4663 25.4797 11.6225 23.107 11.9704 20.8108C12.2384 18.7169 12.6114 16.6342 13.0386 14.5697C13.0607 14.3599 13.0647 14.132 12.9999 13.9293L12.1309 13.8185L12.1417 13.8221Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1045 12.5931C11.5851 11.1619 12.7993 10.6043 14.4142 10.869L14.646 10.8985L14.5153 13.1591L11.6658 12.6489C10.9562 14.6186 10.3275 18.0029 9.90152 21.4312C9.46839 24.8089 9.20179 28.2304 9.41539 30.4014L12.298 30.6332L11.8523 32.8604L11.6314 32.8345C10.0019 32.6856 8.95659 31.84 8.85775 30.3349C8.70528 28.4136 9.06259 24.9019 9.49955 21.4049C9.87394 18.4901 10.1654 15.3545 11.1045 12.5931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1074 34.5656L68.1147 34.5439L68.1617 34.5477C68.1472 34.5549 68.1327 34.5621 68.1219 34.5584L68.1074 34.5656ZM69.5244 23.3984C69.5353 23.402 69.557 23.4093 69.5679 23.413L69.5208 23.4092L69.5244 23.3984ZM67.3487 18.5778C67.7652 18.5608 68.29 18.7973 68.8503 19.4318C69.2732 19.9358 70.1112 21.2547 69.843 23.4571L69.901 23.4645C70.2061 25.0751 70.232 26.8694 69.9461 28.8728L69.9352 28.8692C69.9425 28.8837 69.9388 28.8945 69.9352 28.9053C69.9059 29.0644 69.8912 29.2163 69.8619 29.3754L69.8837 29.3827C69.6593 31.3826 69.1927 33.1323 68.4803 34.6064L68.4116 34.5954C68.118 36.8013 66.9899 37.8583 66.4495 38.244C65.7461 38.7196 65.1809 38.8195 64.79 38.6882L63.952 39.4566C64.2164 39.4609 64.4555 39.4687 64.6402 39.4584C66.8027 39.3157 68.3573 38.7879 68.8338 37.6207C69.7465 35.4779 70.4254 32.3758 70.8292 29.2296C70.833 29.1464 70.8476 29.0669 70.8622 28.9873L70.8514 28.9837C71.226 25.9242 71.3218 22.8677 70.9851 20.6312C70.8098 19.3899 69.435 18.482 67.3898 17.8074C67.2052 17.7454 66.9808 17.6942 66.7092 17.6392L67.3342 18.585L67.3487 18.5778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8164 16.6224L48.3642 15.9927C47.2923 15.9103 46.6437 16.0787 46.5564 16.3027L46.2836 16.9713C46.2254 17.1086 46.7358 17.2799 47.5107 17.3832L49.1329 17.59C50.8927 17.8189 52.3412 17.9312 53.3989 17.9122L56.7963 17.8342C57.5388 17.8181 58.0749 17.7326 58.0897 17.5446L58.1523 16.9623C58.167 16.8466 57.4284 16.671 56.8019 16.6296L56.8164 16.6224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.855 17.8384L53.6614 16.4441L48.3561 16.0505C47.9795 16.0206 47.5919 16.0232 47.2152 16.0656C46.5559 16.158 46.5991 16.3173 46.3371 16.9895C46.3188 17.116 47.253 17.2848 47.3688 17.2996C49.1866 17.5359 51.0079 17.7974 52.8441 17.8348L52.855 17.8384Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2631 16.4892L53.4857 17.8329C54.8983 17.8004 56.336 17.8728 57.7271 17.6883C58.1655 17.6063 58.0607 17.4504 58.1122 16.9731C58.011 16.8426 57.0841 16.7244 56.9356 16.6987L54.2739 16.4928L54.2631 16.4892Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2098 16.8612C58.3837 16.8833 58.5359 16.8258 58.7825 16.6311C59.1814 16.3066 59.0261 16.0855 58.9689 15.644C58.8972 15.1736 58.9768 15.2606 58.7277 14.7788C58.5725 14.4854 58.3842 14.4343 58.0511 14.3827C57.8773 14.3606 57.6924 14.4795 57.7102 14.6423L57.9388 16.5168C57.9566 16.6796 58.036 16.839 58.199 16.8575L58.2098 16.8612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2317 16.8684C58.3947 16.887 58.594 16.797 58.7827 16.6311C58.8479 16.5806 58.8879 16.5337 58.9314 16.476C59.13 16.8563 59.2084 17.5945 58.8789 17.5683C58.5927 17.5567 58.4661 17.5021 58.3466 17.462C58.1946 17.411 58.1481 17.0817 58.2317 16.8684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1251 15.7579L47.4945 15.8095C47.7479 15.8464 47.9617 15.8216 47.9654 15.7746L48.0094 15.4274C48.0131 15.3804 47.8213 15.3039 47.5533 15.2743L47.184 15.2227C46.9305 15.1859 46.7168 15.2106 46.7131 15.2576L46.669 15.6048C46.6617 15.6627 46.8572 15.7283 47.1251 15.7579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4119 20.0731C66.3456 18.615 67.4479 17.8872 68.8288 19.4246C69.277 19.925 70.1041 21.2765 69.8105 23.5186C68.7067 23.0635 66.4714 21.2634 66.4155 20.0622L66.4119 20.0731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1155 34.1099C68.3329 34.0743 68.438 34.0131 68.5796 33.8434C68.6667 33.7279 68.8119 33.5474 68.8704 33.193C69.2343 32.2172 69.5592 30.6734 69.7575 29.1111C69.9557 27.5489 69.9874 25.9789 69.9239 24.9442C69.9535 24.6042 69.8706 24.3833 69.8092 24.2421C69.7227 24.032 69.6286 23.9522 69.4259 23.8721C69.6077 25.5981 69.5179 27.3054 69.3412 28.9834C69.1607 30.7447 68.6034 32.5846 68.13 34.1027L68.1155 34.1099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.721 29.111C69.6732 29.5052 69.5351 29.8087 69.4192 29.7939C69.3033 29.7792 69.2459 29.4462 69.2937 29.052C69.3415 28.6578 69.4796 28.3543 69.5955 28.3691C69.7113 28.3839 69.7687 28.7168 69.721 29.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3087 30.6368L40.7011 34.3172",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7011 34.3172C41.6063 34.4281 42.1023 34.5704 42.0803 34.744",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0803 34.744L42.0068 35.3226",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0069 35.3227C41.9885 35.4492 41.8651 35.6008 41.4341 35.625",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4347 35.6251L39.6235 35.765",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6229 35.7651C38.8296 35.8245 38.5869 35.8275 36.9394 35.6242",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9438 35.6134L11.9297 32.3795",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88339 21.4493L12.9178 21.8406",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9296 25.3505L42.4795 36.76",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5193 13.1482C13.1441 18.9001 12.4061 24.7332 12.291 30.6548",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2477 30.3147L43.4031 34.2953",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2848 30.0254L43.4402 34.006",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5297 13.1881L42.9296 16.7383",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.93 16.7382C43.8352 16.8491 44.3423 16.8504 44.3643 16.6768",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3643 16.6769L44.4449 16.1127",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4443 16.1127C44.4627 15.9862 44.376 15.8123 43.9634 15.6737",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9678 15.6629L42.2448 15.0724",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2442 15.0724C41.495 14.8208 41.256 14.7406 39.6085 14.5374",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6194 14.5411L14.598 11.4012",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89035 21.4638L12.9139 21.8514",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8223 26.2438L45.2723 14.8343",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3844 13.4771L45.5398 17.4577",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3483 13.7664L45.5037 17.747",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8969 34.6157C68.5989 32.8486 69.1672 30.9039 69.4067 28.4988",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3291 23.3328C69.565 25.2218 69.6376 27.2369 69.2568 29.6307",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1859 14.0114L14.1475 30.2723L15.6795 30.4652L17.7179 14.2043L16.1859 14.0114Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2045 14.7693L20.166 31.0302L21.698 31.2231L23.7365 14.9622L22.2045 14.7693Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.223 15.5273L26.1846 31.7882L27.7166 31.9811L29.755 15.7202L28.223 15.5273Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2406 16.2853L32.2021 32.5462L33.7342 32.7392L35.7726 16.4782L34.2406 16.2853Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2592 17.0433L38.2207 33.3042L39.7527 33.4972L41.7912 17.2363L40.2592 17.0433Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_16190",
    x: 0.810547,
    y: 2.80179,
    width: 78.3867,
    height: 45.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_16190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_16190",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBus);
export default __webpack_public_path__ + "static/media/redBus.a7681bbdeaba2e5edb6a8bee13c11a43.svg";
export { ForwardRef as ReactComponent };